module.exports = __webpack_public_path__ + "media/images/screens/08_suggestionProduits-a8aedf0ab7ce21b2012d91ee136f9b23.jpg";